import { createReducer, on } from '@ngrx/store';
import {
  deleteFileAttachments,
  getFileAttachments,
  saveFileAttachments,
  updateFileAttachments,
  setFileAttachments,
  saveFileAttachmentsForOrder
} from '../actions/fileattachments.actions';

export interface FileAttachmentsState {
  data: any;
}

export const initialState: FileAttachmentsState = {
  data: {}
};

export const fileattachmentsReducer = createReducer(
  initialState,
  on(getFileAttachments, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setFileAttachments, (state, { fileAttachmentsDataOrder }) => ({
    ...state,
    ...{ fileAttachmentsDataOrder }
  })),
  on(saveFileAttachments, (state, { fileAttachmentsData }) => ({
    ...state,
    ...fileAttachmentsData
  })),
  on(saveFileAttachmentsForOrder, (state, { fileAttachmentsData }) => ({
    ...state,
    ...fileAttachmentsData
  })),
  on(updateFileAttachments, (state, { fileAttachmentsData }) => {
    return {
      ...state,
      ...fileAttachmentsData
    };
  }),
  on(deleteFileAttachments, (state) => {
    return {
      ...state
    };
  })
);
